export default {
    ['repair']: 'Repair',
    ['new-wig']: 'New wig',
    none: 'ללא',
    full: 'שלימה',
    fall: 'סרט',
    'kipa-fall': 'כיפה פול',
    'hand-made': 'עבודת יד',
}
